import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import DokterService from "@/services/SoapDokter";
import PerawatService from "@/services/SoapPerawat";
import { SoapResponseItem } from "@/types/soap";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "new-soap-store"
})
class NewSoapStore extends VuexModule {
  loadingSoapDokter = false;
  loadingList = false;
  soapDokterList: SoapResponseItem[] = [];
  soapPerawatList: SoapResponseItem[] = [];

  get soapList() {
    return [...this.soapDokterList, ...this.soapPerawatList].sort((a, b) => { return new Date(a.examined_at).getTime() - new Date(b.examined_at).getTime() });
  }

  @Mutation
  SET_SOAP_DOKTER_LIST(val: SoapResponseItem[]) {
    this.soapDokterList = val;
  }

  @Mutation
  SET_SOAP_PERAWAT_LIST(val: SoapResponseItem[]) {
    this.soapPerawatList = val;
  }

  @Mutation
  SET_SOAP_DOKTER_LOADING(val: boolean) {
    this.loadingSoapDokter = val;
  }

  @Mutation
  SET_SOAP_LIST_LOADING(val: boolean) {
    this.loadingList = val;
  }

  @Mutation
  RESET_SOAP_DOKTER_LIST() {
    this.soapDokterList = [];
  }

  @Mutation
  RESET_SOAP_PERAWAT_LIST() {
    this.soapPerawatList = [];
  }

  @Mutation
  RESET_SOAP_LIST() {
    this.soapDokterList = [];
    this.soapPerawatList = [];
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_SOAP_LIST_LOADING(true);

    const soapDokter = await DokterService.getByRegister(registerId)

    const soapPerawat = await PerawatService.getByRegister(registerId)

    this.SET_SOAP_DOKTER_LIST(soapDokter.data);
    this.SET_SOAP_PERAWAT_LIST(soapPerawat.data);

    this.SET_SOAP_LIST_LOADING(false);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_SOAP_LIST();
  }
}

export default getModule(NewSoapStore);
